export default {
  HANDLE_SUCCESS_GET_CLIENTS: 'handleSuccessGetClients',
  TOGGLE_CONVERT_USER_MODAL: 'toggleConvertUserModal',
  TOGGLE_EXPORT_TABLE_MODAL: 'toggleExportTableModal',
};



// WEBPACK FOOTER //
// ./src/app/main/clients/constants/action-types.js